import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python If Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python if tutorial for beginners. Python If is used for making a decision.If and else can be a block statement" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Python if then else syntax,Python if and or,Python if then  else ,Python if or,Python if elif,Python if else statement
,Python if in,Python if statement,Python if ,Python if else,python if statement syntax,Python if syntax" />
<link rel="canonical" href="https://www.codeexampler.com/python-if" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Python if Statement</h1>
    
    <div className="first">
        <a href="/python-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <p className="mt-4 para">Python-If uses it for making a decision. If and else can be a block statement
</p>

<h2 className='headings'>Python if statement Syntax:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-6">if</span>
                <span className="qwerty-7"> condition</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-3">   statement</span>
            {"\n"}{"\n"}
                 </code>
        </pre>   
        </div>     




   <h2 className='headings'>Q-Write a program to input a number and check this number is more than or equal to 100 in Python if statement?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">500</span>
             {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-2">100</span>
                 <span className="qwerty-1">: </span>
             {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">a is greater</span>
                 <span className="qwerty-1">")</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-3">a</span>
                        <span className="qwerty-2"> is greater</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>


<h2 className='headings'>Q-Write a program to input a number and print multiple no in Python if statement?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">1000</span>
             {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">800</span>
             {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-2">500</span>
                 <span className="qwerty-1">: </span>
             {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">a</span>
                 <span className="qwerty-1">")</span>
             {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-4"> b</span>
                 <span className="qwerty">&#60;</span>
                 <span className="qwerty-2">1000</span>
                 <span className="qwerty-1">: </span>
             {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">b is less</span>
                 <span className="qwerty-1">")</span>
             {"\n"}
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">all are correct</span>
                 <span className="qwerty-1">")</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-3">a</span>
                    {"\n"}
                        <span className="qwerty-3">b</span>
                        <span className="qwerty-2"> is less</span>
                        {"\n"}      
                        <span className="qwerty-4">all are correct</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>



    
    <h2 className='headings'>Q-Write a program give three numbers and print multiple more excellent no in Python if statement?</h2>
      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
     <pre style={{maxHeight:"500vh"}}>
         <code >
           {"\n"}
               <span className="qwerty-4">a</span>
               <span className="qwerty-1">=</span>
               <span className="qwerty-2">100</span>
               <span className="qwerty-1">; </span>
               <span className="qwerty-4">b</span>
               <span className="qwerty-1">=</span>
               <span className="qwerty-2">200</span>
               <span className="qwerty-1">; </span>
               <span className="qwerty-4">c</span>
               <span className="qwerty-1">=</span>
               <span className="qwerty-2">400</span>
               <span className="qwerty-1">; </span>
           {"\n"}
               <span className="qwerty-6">if</span>
               <span className="qwerty-4"> a</span>
               <span className="qwerty">&#62;</span>
               <span className="qwerty-4">b</span>
               <span className="qwerty-1">: </span>
           {"\n"}
               <span className="qwerty-3">    print</span>
               <span className="qwerty-1">("</span>
               <span className="qwerty-10">a is greater</span>
               <span className="qwerty-1">")</span>
           {"\n"}
               <span className="qwerty-6">if</span>
               <span className="qwerty-4"> a</span>
               <span className="qwerty">&#60;</span>
               <span className="qwerty-4">b</span>
               <span className="qwerty-1">: </span>
           {"\n"}
               <span className="qwerty-3">    print</span>
               <span className="qwerty-1">("</span>
               <span className="qwerty-10">b is greater</span>
               <span className="qwerty-1">")</span>
           {"\n"}
               <span className="qwerty-6">if</span>
               <span className="qwerty-4"> a</span>
               <span className="qwerty">&#60;</span>
               <span className="qwerty-4">c</span>
               <span className="qwerty-1">: </span>
           {"\n"}
               <span className="qwerty-3">    print</span>
               <span className="qwerty-1">("</span>
               <span className="qwerty-10">c is greater</span>
               <span className="qwerty-1">")</span>
           {"\n"}
           {"\n"}
                </code>
       </pre>
       </div> 
       <h5 className='headings'> Output : </h5>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
              <code >
                  {"\n"}
                      <span className="qwerty-3">b</span>
                      <span className="qwerty-2"> is greater</span>
                  {"\n"}
                      <span className="qwerty-3">c</span>
                      <span className="qwerty-2"> is greater</span>
                      {"\n"}      {"\n"}      
            </code>
              </pre>
              </div>


  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/python-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Pif;